export enum APIPrefix {
  Admin = 'cms',
  Client = 'client',
  PMS = 'pms'
}
